import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=d49fc89c&scoped=true&"
import script from "./Contato.vue?vue&type=script&lang=js&"
export * from "./Contato.vue?vue&type=script&lang=js&"
import style0 from "./Contato.vue?vue&type=style&index=0&id=d49fc89c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49fc89c",
  null
  
)

export default component.exports